module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc11-31311fd6b14ac6dfc8dd246b9ba1f848.jpg";